import React from 'react';
import { useSelector } from 'react-redux';
import { Reducers } from './Interfaces/Interfaces';
import { SnackbarProvider } from 'notistack';
import SecuredLayout from './layout/SecuredLayout/SecuredLayout';
import OpenLayout from './layout/OpenLayout/OpenLayout';
import { BrowserRouter as Router } from 'react-router-dom';


function App() {
  let auth = useSelector((state: Reducers) => state.auth);
  let isPasswordChange = JSON.parse(localStorage.getItem("passwordChanged") || "true");

  return (
    <Router>
      <SnackbarProvider maxSnack={1} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        {auth && isPasswordChange ? <SecuredLayout /> : <OpenLayout />}
      </SnackbarProvider>
    </Router>
  );
}

export default App;
